import React, { Component } from "react";
import CSSClasses from "./UserInfo.css";
import { connect } from "react-redux";
import * as StoreActions from "../../ReduxStore/Actions/ActionIndex";

import iconInfoInactive from "../../assets/images/icons/icon_info_inactive.png";
import iconInfoActive from "../../assets/images/icons/icon_info_active.png";
import SiteIcons from "../../assets/fonts/site_icons/style.css";

import beepMedium from "../../assets/sounds/beep_medium.mp3";
import * as LocalStorageKeys from "../../HOCs/Constants/LocalStorageKeys";

class UserInfo extends Component {
  state = { isSaldoShown: true };

  render() {
    return (
      <div className={CSSClasses.container}>
        <audio
          ref={sound => {
            this.beepMedium = sound;
          }}
        >
          <source src={beepMedium} type="audio/mpeg" />
        </audio>

        <div className={CSSClasses.leftSection}>
          <div className={CSSClasses.quarterRow}>Bonus:</div>
          <div className={[CSSClasses.quarterRow, CSSClasses.orange].join(" ")}>
            0,00{this.props.machineInfo.CurrencyCode}
          </div>
          <div className={CSSClasses.quarterRow}>Aktiv bonus:</div>
          <div className={[CSSClasses.quarterRow, CSSClasses.green].join(" ")}>
            0,00{this.props.machineInfo.CurrencyCode}
          </div>
          <div
            className={CSSClasses.infoBtnBox}
            onClick={() => {
              this.btnInfo_Click();
            }}
          >
            <img
              src={
                this.props.isShowingBonusInfo
                  ? iconInfoActive
                  : iconInfoInactive
              }
              alt=""
            />
          </div>
        </div>
        <div className={CSSClasses.rightSection}>
          <div
            className={[CSSClasses.halfRow, CSSClasses.saldoLegend].join(" ")}
          >
            Saldo
            {this.state.isSaldoShown ? (
              <span
                onClick={() => {
                  this.setState({ isSaldoShown: !this.state.isSaldoShown });
                }}
                className={[
                  SiteIcons.site_icon_eye_crossed,
                  CSSClasses.iconEye,
                  CSSClasses.iconSmaller
                ].join(" ")}
              />
            ) : (
              <span
                onClick={() => {
                  this.setState({ isSaldoShown: !this.state.isSaldoShown });
                }}
                className={[SiteIcons.site_icon_eye, CSSClasses.iconEye].join(
                  " "
                )}
              />
            )}
          </div>
          <div
            className={[CSSClasses.halfRow, CSSClasses.saldoLabel].join(" ")}
          >
            {this.state.isSaldoShown ? (
              (this.props.currentBalance * 0.01).toFixed(2).replace(".", ",") +
              this.props.machineInfo.CurrencyCode
            ) : (
              <span>&nbsp;</span>
            )}
          </div>
        </div>
      </div>
    );
  }

  btnInfo_Click = () => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    if (this.props.isShowingBonusInfo) {
      //pokazuje vec, znaci gasi se, daj timeout za show extras
      //nakon timeouta upali
      setTimeout(() => {
        this.props.setCanShowExtraLiveBets(true);
        console.log("PALIM...");
      }, 1000);
    } else {
      //skrij extras
      this.props.setCanShowExtraLiveBets(false);
      this.props.onSetLiveExtraBetsID(-1);
      this.props.setShouldQuickCloseExtraBets(false);
    }

    this.props.setIsShowingBonusInfo(!this.props.isShowingBonusInfo);
  };
}

const mapStateToProps = state => {
  return {
    currentBalance: state.rrBalance.currentBalance,
    isShowingBonusInfo: state.rrNavigation.isShowingBonusInfo,
    machineInfo: state.rrAppState.machineInfo
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setIsShowingBonusInfo: isShown =>
      dispatch(StoreActions.SetIsShowingBonusInfo(isShown)),
    setCanShowExtraLiveBets: canShow =>
      dispatch(StoreActions.SetCanShowExtraLiveBets(canShow)),
    onSetLiveExtraBetsID: betsID =>
      dispatch(StoreActions.ChangeCurrentLiveExtraBetsID(betsID)),
    setShouldQuickCloseExtraBets: shouldClose =>
      dispatch(StoreActions.SetShouldQuickCloseExtraBets(shouldClose))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserInfo);



// WEBPACK FOOTER //
// ./src/Components/UserInfo/UserInfo.js